import React, { useState, useEffect, useRef  } from "react";
import Cropper from "react-easy-crop";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import defaultImage from "../images/demo.jpeg";
import { baseurl, caturl } from "../utility/helper";
import "../assets/css/Profile.css";
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2';
import HiddenPayuForm from "../components/forms/HiddenPayuForm";

// ── Same config used in Register.js ──────────────────────────────────────────
const ID_TYPE_CONFIG = {
  aadhaar: {
    label: "Aadhaar Card",
    placeholder: "Last 4 digits of Aadhaar",
    pattern: /^\d{4}$/,
    hint: "Must be exactly 4 digits (0–9).",
  },
  pan: {
    label: "PAN Card",
    placeholder: "Last 4 characters of PAN (e.g. 234F)",
    pattern: /^[A-Za-z0-9]{4}$/,
    hint: "Must be exactly 4 alphanumeric characters.",
  },
  driving_license: {
    label: "Driving License",
    placeholder: "Last 4 characters of DL number",
    pattern: /^[A-Za-z0-9]{4}$/,
    hint: "Must be exactly 4 alphanumeric characters.",
  },
  passport: {
    label: "Passport",
    placeholder: "Last 4 characters of Passport number",
    pattern: /^[A-Za-z0-9]{4}$/,
    hint: "Must be exactly 4 alphanumeric characters.",
  },
};
// ─────────────────────────────────────────────────────────────────────────────

const Profile = () => {
  const mid = parseInt(sessionStorage.getItem("MemberID")) || null;
  const cid = parseInt(sessionStorage.getItem("CandidateID")) || null;
  const location = useLocation();
  const { state } = location || {};
  const defaultTab = state?.defaultTab || "#one"; 
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const userType = location.state?.type || queryParams.get('usertype')
  const cardRef = useRef();
  const [tests, setTests] = useState([]);
  const [membertrans,setTransData] = useState([]);
  const [pretests, setPreTests] = useState([]);
  const [prior, setPrior] = useState([]);
  const [member, setMember] = useState([]);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    gender: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    image: "",
    aadhar_last: "",
    id_type: "aadhaar",   // ← new
  });
  const [profilePic, setProfilePic] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [modalIsOpen1, setIsOpen1] = useState(false);
  const [show, setShow] = useState(false);
  const [intshow, setintShow] = useState(false);
  const [chapter, setChapter] = useState('');
  const [reason, setReason] = useState('');
  const [chapters, setChapters] = useState([]);
  const [feeData, setFeeData] = useState({});
  const handleClose = () => setShow(false);
  const handleintClose = () => setintShow(false);
  const handleShow = () => setShow(true);
  const handleInternationalShow = () => setintShow(true);
  const [originalProfile, setOriginalProfile] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const FREE_CARD_MEMBERSHIP_IDS = ["1", "2"];
  const [selectedTerm, setSelectedTerm] = useState("");
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [terms, setTerms] = useState([]);
  // ── ID field validation error ─────────────────────────────────────────────
  const [idError, setIdError] = useState("");
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null); // raw selected image (data URL)
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [addFileSelections, setAddFileSelections] = useState({});
  const [addingFileId, setAddingFileId] = useState(null);
  const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1 MB
  const [plaqueAddressConfirmed, setPlaqueAddressConfirmed] = useState(false);
  const [showPlaqueModal, setShowPlaqueModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mid = parseInt(sessionStorage.getItem("MemberID")) || null;

    const payload = {
      member_id: mid,
      from_chapter_id: member.chapter_id,
      to_chapter_id: chapter,
      reason: reason
    };

    try {
      const response = await axios.post(`${baseurl}/submit-request`, payload);
      console.log("Response from API:", response.data);
      Swal.fire({
        title: 'Success!',
        text: 'Transfer request submitted successfully.',
        icon: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        handleClose();
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        title: 'Error!',
        text: 'There was a problem submitting your request.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  const handleintSubmit = async (e) => {
    e.preventDefault();

    const mid = parseInt(sessionStorage.getItem("MemberID")) || null;

    const payload = {
      member_id: mid,
      reason: reason,
      member_status: member.memberstatus_id,
    };

    try {
      const response = await axios.post(`${baseurl}/international_request`, payload);
      console.log("Response from API:", response.data);
      Swal.fire({
        title: 'Success!',
        text: 'Transfer request submitted successfully.',
        icon: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        handleintClose();
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        title: 'Error!',
        text: 'There was a problem submitting your request.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  useEffect(() => {
    window.onpageshow = function () {
      setSelectedTerm("");
    };
  }, []);
  useEffect(() => {
    if (defaultTab) {
      const tabElement = document.querySelector(`a[href="${defaultTab}"]`);
      if (tabElement) {
        tabElement.click();
      }
    }
  }, [defaultTab]);

  useEffect(() => {
    axios.get(`${baseurl}/chapters`)
      .then(res => setChapters(res.data))
      .catch(err => console.error('Failed to fetch chapters:', err));
  }, []);

  useEffect(() => {
    fetchMemberDetails();
    const mid = parseInt(sessionStorage.getItem("MemberID")) || null;
    if (mid === null || mid === '') {
      fetchTests();
      fetchPrior();
      fetchPreTests();
    } else {
      fetchTrans();
    }
    fetchProfile();
  }, []);

  function getCroppedImage(imageSrc, cropPixels) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = cropPixels.width;
        canvas.height = cropPixels.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
          image,
          cropPixels.x,
          cropPixels.y,
          cropPixels.width,
          cropPixels.height,
          0,
          0,
          cropPixels.width,
          cropPixels.height
        );

        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          resolve(blob);
        }, "image/jpeg", 0.9);
      };
      image.onerror = (err) => reject(err);
    });
  }

  const downloadCardImage = async () => {
    const card = cardRef.current;

    if (!card) {
      console.error("Card element not found");
      return;
    }

    try {
      const canvas = await html2canvas(card, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#ffffff",
        scale: 2,
        logging: false,
      });

      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Failed to create PNG");
          return;
        }

        const fileName = `MensaCard_${
          member?.[0]?.membership_no || "Card"
        }.png`;

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }, "image/png");

    } catch (error) {
      console.error("Error downloading card:", error);
    }
  };
  useEffect(() => {
    const profileChanged =
      JSON.stringify(profile) !== JSON.stringify(originalProfile);

    const imageChanged =
      profilePic &&
      profilePic !== originalProfile.image &&
      profilePic !== defaultImage;

    setIsChanged(profileChanged || imageChanged);
  }, [profile, profilePic, originalProfile]);

  const fetchMemberDetails = async () => {
    try {
      const mid = parseInt(sessionStorage.getItem("MemberID")) || null;

      if (!mid) {
        setError("Invalid Member ID.");
        return;
      }

      const response = await axios.get(`${baseurl}/member/membership_details/${mid}`);

      if (response.data) {
        setMember(response.data);
        console.log("Fetched Member Details:", response.data);
      } else {
        setError("No data found for the provided Member ID.");
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Failed to fetch membership details. Please try again later.");
    }
  };

  const handleOrderCard = async () => {
    const expiryDate = new Date(member.membership_exp_date).toLocaleDateString("en-CA");
    if (!imageFile && (!profile.image || profile.image.trim() === "")) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please Add image in Profile",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
      });
      setIsSaving(false);
      return;
    }
    try {
      const response = await fetch(`${baseurl}/member/ordercard`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          member_id: mid,
          expiry_date: expiryDate,
        }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Your order has been placed successfully!");
        window.location.reload();
      } else {
        alert(data.message || "Something went wrong, please try again.");
      }
    } catch (error) {
      console.error("Error ordering card:", error);
      alert("Failed to place order. Please try again.");
    }
  };


  const fetchTests = async () => {
    try {
      const id = parseInt(sessionStorage.getItem("CandidateID")) || null;
      const response = await axios.get(`${baseurl}/candidate/tests/${id}`);
      setTests(response.data);
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };

  const fetchTrans = async () => {
    const mid = parseInt(sessionStorage.getItem("MemberID")) || null;
    try {
      const response = await axios.get(`${baseurl}/admin/member_transaction/${mid}`);
      setTransData(response.data);
      console.log('Transaction:', response.data);
    } catch (error) {
      console.error('Error fetching member history:', error);
    }
  };

  const fetchPreTests = async () => {
    try {
      const id = parseInt(sessionStorage.getItem("CandidateID")) || null;
      const response = await axios.get(`${baseurl}/candidate/pretests/${id}`);
      setPreTests(response.data);
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };

  const fetchPrior = async () => {
    try {
      const id = parseInt(sessionStorage.getItem("CandidateID")) || null;
      const response = await axios.get(`${baseurl}/candidate/prior/${id}`);
      setPrior(response.data);
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };

  function toDateOnly(dateStr) {
    if (!dateStr) return null;
    return new Date(dateStr.toString().split("T")[0]);
  }

  function isFreeCardEligible(member) {
    const isNewMember = !member.last_renewal_date;
    if (member.free_card_used) return false;
    if (isNewMember && !member.card_id) return true;
    const is5YearOrLife = FREE_CARD_MEMBERSHIP_IDS.includes(String(member.memberstatus_id));
    if (is5YearOrLife && member.last_renewal_date && !member.card_id) return true;
    if (is5YearOrLife && member.last_renewal_date && member.expiry_date) {
      const cardExpiry  = toDateOnly(member.expiry_date);
      const lastRenewal = toDateOnly(member.last_renewal_date);
      if (cardExpiry < lastRenewal) return true;
    }
    return false;
  }

  const emptyProfile = {
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    gender: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    aadhar_last: "",
    image: "",
    id_type: "aadhaar",   // ← new
    last_edu: "",
  };

  const fetchProfile = async () => {
    try {
      let id = null;
      let memberID = null;
      let endpoint = "";

      console.log("User Type:", userType);

      if (userType === "candidate") {
        id = parseInt(sessionStorage.getItem("CandidateID")) || null;
        endpoint = `${baseurl}/candidate/profile/${id}`;
        if (!id) {
          console.error("Candidate ID not found");
          return;
        }
      } else if (userType === "member") {
        memberID = parseInt(sessionStorage.getItem("MemberID")) || null;
        endpoint = `${baseurl}/member/profile/${memberID}`;
        if (!memberID) {
          console.error("Member ID not found");
          return;
        }
      } else {
        alert("Not Found Profile.");
        console.error("Invalid userType or userType not set");
        return;
      }

      console.log("Fetching data from:", endpoint);

      const response = await axios.get(endpoint);
      const data = response.data;

      if (!data || Object.keys(data).length === 0) {
        console.warn("Empty profile data received. Clearing previous data.");
        setProfile(emptyProfile);
        setOriginalProfile(emptyProfile);
        setProfilePic(defaultImage);
        return;
      }

      const formattedDOB = data.dob ? convertDateFormat(data.dob) : "";

      let normalizedProfile = {};
      if (userType === "candidate") {
        normalizedProfile = {
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          email: data.email || "",
          mobile_no: data.mobile_no || "",
          gender: data.gender || "",
          dob: formattedDOB,
          address: data.address || "",
          city: data.city || "",
          state: data.state || "",
          pincode: data.pincode || "",
          aadhar_last: data.aadhar_last || "",
          image: data.candidate_img || "",
          id_type: data.id_type || "aadhaar",   // ← new
          last_edu: data.last_education || "",   // ← add
        };
      } else if (userType === "member") {
        normalizedProfile = {
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          email: data.email || "",
          mobile_no: data.mobile_no || "",
          gender: data.gender || "",
          dob: formattedDOB,
          address: data.present_address || "",
          city: data.present_city || "",
          state: data.present_state || "",
          pincode: data.present_pincode || "",
          aadhar_last: data.aadhar_last || "",
          image: data.member_img || "",
          id_type: data.id_type || "aadhaar",   // ← new
          
        };
      }

      setProfile(normalizedProfile);
      setOriginalProfile(normalizedProfile);
      setProfilePic(normalizedProfile.image || defaultImage);

    } catch (error) {
      console.error("Error fetching profile:", error);
      setProfile(emptyProfile);
      setOriginalProfile(emptyProfile);
      setProfilePic(defaultImage);
    }
  };

  const convertDateFormat = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error("Invalid date format:", dateString);
      return dateString;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // When ID type changes, clear the last-4 field
    if (name === "id_type") {
      setIdError("");
      setProfile(prev => ({ ...prev, id_type: value, aadhar_last: "" }));
      return;
    }
    setProfile((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleEditClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageToCrop(reader.result);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    }
    // Reset the input so selecting the same file again still triggers onChange
    event.target.value = "";
  };

  const onCropComplete = (_croppedArea, croppedAreaPixelsResult) => {
    setCroppedAreaPixels(croppedAreaPixelsResult);
  };

  const handleCropConfirm = async () => {
    try {
      const croppedBlob = await getCroppedImage(imageToCrop, croppedAreaPixels);
      const croppedFile = new File([croppedBlob], "profile.jpg", { type: "image/jpeg" });

      setImageFile(croppedFile);

      // Convert the cropped blob to a data URL for preview + upload payload
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
      };
      reader.readAsDataURL(croppedBlob);

      setShowCropModal(false);
      setImageToCrop(null);
    } catch (err) {
      console.error("Error cropping image:", err);
      Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: "Failed to crop image, please try again.",
        showConfirmButton: false, timer: 2000, timerProgressBar: true
      });
    }
  };

  const handleCropCancel = () => {
    setShowCropModal(false);
    setImageToCrop(null);
  };

  // ── Validate the ID last-4 field; returns error string or "" ─────────────
  const validateIdField = () => {
    const cfg = ID_TYPE_CONFIG[profile.id_type] || ID_TYPE_CONFIG.aadhaar;
    const trimmed = (profile.aadhar_last || "").trim();

    if (!trimmed) {
      return `Last 4 characters of your ${cfg.label} are required.`;
    }
    if (!cfg.pattern.test(trimmed)) {
      return cfg.hint;
    }
    if (/^(.)\1{3}$/i.test(trimmed)) {
      return `"${trimmed.toUpperCase()}" is not a valid ID number. Please enter the actual last 4 characters of your ${cfg.label}.`;
    }
    return "";
  };

  const updateProfile = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    // ── Validate ID field first ───────────────────────────────────────────
    if (mid === null){
    const idValidationError = validateIdField();
    if (idValidationError) {
      setIdError(idValidationError);
      setIsSaving(false);
      return;
    }
    }
    setIdError("");
    // ─────────────────────────────────────────────────────────────────────

    // NEW: capture BEFORE the save/fetch cycle overwrites originalProfile
    const emailChanged =
      (originalProfile.email || "").trim().toLowerCase() !==
      (profile.email || "").trim().toLowerCase();

    // NEW: warn and confirm BEFORE saving if the email id was changed
    if (emailChanged) {
      const confirmResult = await Swal.fire({
        icon: 'warning',
        title: 'Change Email ID?',
        text: 'If you change your email id then you will be logged out of your account. You will need to login again using your changed email id.',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
      if (!confirmResult.isConfirmed) {
        setIsSaving(false);
        return;
      }
    }

    try {
      let Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
      let memberID = parseInt(sessionStorage.getItem("MemberID")) || null;

      let apiUrl = "";
      if (Candidateid) {
        apiUrl = `${baseurl}/candidate/profile/${Candidateid}`;
      } else if (memberID) {
        apiUrl = `${baseurl}/member/profile/${memberID}`;
      } else {
        alert("No Candidate ID or Member ID found.");
        setIsSaving(false);
        return;
      }
      if (!profile.dob) {
        alert("Date of Birth is required.");
        setIsSaving(false);
      } else {
        const today = new Date();
        const birthDate = new Date(profile.dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 1) {
          alert("Your age is below 1 year. You are not eligible.");
          setIsSaving(false);
          return;
        }
      }
      if (!imageFile && (!profile.image || profile.image.trim() === "")) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Please select image",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });
        setIsSaving(false);
        return;
      }

            // Add this validation before the try block (after idValidationError check)
      if ((!profile.last_edu || profile.last_edu.trim() === "") && memberID === null ) {
        Swal.fire({
          toast: true, position: "top-end", icon: "error",
          title: "Last Education is required.",
          showConfirmButton: false, timer: 2000, timerProgressBar: true
        });
        setIsSaving(false);
        return;
      }

      const updatedData = {
        first_name: profile.first_name,
        last_name: profile.last_name,
        email: profile.email,
        mobile_no: profile.mobile_no,
        gender: profile.gender,
        dob: profile.dob,
        address: profile.address || profile.present_address,
        city: profile.city || profile.present_city,
        state: profile.state || profile.present_state,
        pincode: profile.pincode || profile.present_pincode,
        aadhar_last: profile.aadhar_last.toUpperCase(), // normalise
        id_type: profile.id_type,                       // ← new
        image: profilePic || profile.image,
        last_edu: (profile.last_edu || '').trim(),  // ← add this
      };
      console.log('profile update:', updatedData);
      const response = await axios.put(apiUrl, updatedData);

      if (response.status === 200) {
        if (Candidateid) {
          sessionStorage.setItem("CandidateFname", profile.first_name || "");
          sessionStorage.setItem("CandidateLname", profile.last_name || "");
          sessionStorage.setItem("CandidateEmail", profile.email || "");
          sessionStorage.setItem("CandidateMobile", profile.mobile_no || "");
          sessionStorage.setItem("Candidategender", profile.gender || "");
          sessionStorage.setItem("Candidatedob", profile.dob || "");
          sessionStorage.setItem("Candidateaadhar", profile.aadhar_last || "");
          sessionStorage.setItem("Candidatepriviledge", profile.priviledge || "");
        }

        if (memberID) {
          sessionStorage.setItem("MemberFname", profile.first_name || "");
          sessionStorage.setItem("MemberLname", profile.last_name || "");
          sessionStorage.setItem("MemberEmail", profile.email || "");
          sessionStorage.setItem("MemberMobile", profile.mobile_no || "");
        }
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Profile updated successfully",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        }).then(() => {
          setIsSaving(false);
          setIsChanged(false);

          // NEW: email id was changed — already confirmed before saving, so log out now
          if (emailChanged) {
            handleLogout();
          } else {
            fetchProfile();
          }
        });
      }

    } catch (error) {
      console.error("Error updating profile:", error);
      setIsSaving(false);
    }
  };

  const handleLogout = () => {
    if (userType === "candidate") {
      sessionStorage.removeItem("CandidateID");
      sessionStorage.removeItem("CandidateFname");
      sessionStorage.removeItem("CandidateLname");
      sessionStorage.removeItem("CandidateEmail");
      sessionStorage.removeItem("CandidateMobile");
    } else if (userType === "member") {
      sessionStorage.removeItem("MemberID");
      sessionStorage.removeItem("MemberFname");
      sessionStorage.removeItem("MemberLname");
      sessionStorage.removeItem("MemberEmail");
      sessionStorage.removeItem("MemberMobile");
    }
    sessionStorage.removeItem("userType");
    window.location.href = "/";
  };

  // jsPDF's addImage needs to know the real codec to use (PNG vs JPEG
  // decoder) — forcing the wrong one throws "Incomplete or corrupt PNG/JPEG
  // file". Detect it from a data URL's mime type, or fall back to the file
  // extension for plain image paths (e.g. webpack asset URLs).
  const getImageFormat = (src) => {
    if (!src) return 'JPEG';
    if (src.startsWith('data:image/png'))  return 'PNG';
    if (src.startsWith('data:image/jpeg') || src.startsWith('data:image/jpg')) return 'JPEG';
    if (src.startsWith('data:image/webp')) return 'WEBP';
    if (/\.png(\?|$)/i.test(src))          return 'PNG';
    if (/\.(jpe?g)(\?|$)/i.test(src))      return 'JPEG';
    if (/\.webp(\?|$)/i.test(src))         return 'WEBP';
    return 'JPEG';
  };

  // Shrink an image (URL or data URL) to a JPEG data URL of at most maxBytes,
  // keeping the CAT request under the nginx body-size limit (413 otherwise).
  const compressImage = (src, maxBytes = 20 * 1024) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        let scale = Math.min(1, 400 / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        for (let attempt = 0; attempt < 8; attempt++) {
          canvas.width = Math.max(1, Math.round(img.width * scale));
          canvas.height = Math.max(1, Math.round(img.height * scale));
          ctx.fillStyle = "#fff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          for (let q = 0.8; q >= 0.3; q -= 0.1) {
            const dataUrl = canvas.toDataURL("image/jpeg", q);
            // base64 length * 3/4 ≈ decoded byte size
            if ((dataUrl.length - dataUrl.indexOf(",") - 1) * 0.75 <= maxBytes) {
              return resolve(dataUrl);
            }
          }
          scale *= 0.75;
        }
        reject(new Error("Could not compress image below size limit"));
      };
      img.onerror = () => reject(new Error("Could not load profile image"));
      img.src = src;
    });

  const buildCatPayload = (profileImageUrl) => ({
    firstName: profile.first_name || "",
    middleName: "",
    lastName: profile.last_name || "",
    emailid: profile.email || "",
    phone: profile.mobile_no || "",
    dateOfBirth: profile.dob ? String(profile.dob).slice(0, 10) : "",
    gender: profile.gender || "",
    aadharNumber: profile.aadhar_last || "",
    state: profile.state || "",
    city: profile.city || "",
    pincode: profile.pincode || "",
    education: profile.last_edu || "",
    profileImageUrl,
    studentId: `${cid}`,
    registrationStatus: "Registered",
  });

  // Both Energia endpoints return a one-time redirectUrl that the candidate
  // must be sent to (the hall-ticket token expires in 5 minutes).
  const redirectToProctor = async (path, payload, failMsg) => {
    try {
      const response = await axios.post(`${caturl}${path}`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.data?.success && response.data?.redirectUrl) {
        window.location.href = response.data.redirectUrl;
      } else {
        Swal.fire("Error", response.data?.message || failMsg, "error");
      }
    } catch (err) {
      console.error(failMsg, err);
      const data = err.response?.data;
      // ASP.NET validation errors: { errors: { Field: ["msg"] }, title }
      const fieldErrors = data?.errors && typeof data.errors === "object"
        ? Object.values(data.errors).flat().join("\n")
        : "";
      const detail =
        data?.message ||
        fieldErrors ||
        data?.title ||
        (typeof data === "string" ? data : "") ||
        err.message;
      Swal.fire({
        icon: "error",
        title: failMsg,
        text: detail && detail !== failMsg ? detail : undefined,
      });
    }
  };

  // Book: register the candidate and book the exam on Energia.
  const registerCat = async () => {
    let profileImageUrl = null;
    const src = profilePic || profile.image;
    if (src) {
      try {
        profileImageUrl = await compressImage(src);
      } catch (err) {
        console.error("Image compression failed:", err);
        Swal.fire("Error", "Could not process your profile image. Please re-upload it and try again.", "error");
        return;
      }
    }
    return redirectToProctor("/api/Proctoring/signup-and-book", buildCatPayload(profileImageUrl), "CAT registration failed.");
  };

  // View: open the candidate's existing booking / hall ticket on Energia.
  const viewCatRegistration = () =>
    redirectToProctor("/api/Proctoring/hall-ticket-link", { studentId: `${cid}` }, "Could not open hall ticket.");

  const downloadHallTicket = (test, candidate = {}) => {
    console.log(candidate);
    const doc = new jsPDF();

    const primaryColor = [30, 11, 104];
    const secondaryColor = [52, 73, 94];
    const lightGray = [236, 240, 241];

    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 210, 35, 'F');

    const imageSource = 'assets/img/logo/mensatrans.png';
    try {
      doc.addImage(imageSource, getImageFormat(imageSource), 5, 5, 70, 20);
    } catch (err) {
      console.error('Failed to embed logo in hall ticket:', err);
    }

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(15);
    doc.setFont('helvetica', 'bold');
    doc.text('HALL TICKET', 105, 15, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('EXAMINATION ADMIT CARD', 105, 25, { align: 'center' });
    
    const hallTicketNo = test?.hall_ticket_no || 'ROLL001';

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('HallTicket No:', 200, 18, { align: 'right' });

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(hallTicketNo, 200, 25, { align: 'right' });

    doc.setTextColor(0, 0, 0);
    
    let profileImageDrawn = false;
    if (profilePic) {
      try {
        doc.addImage(profilePic, getImageFormat(profilePic), 150, 45, 45, 45);
        profileImageDrawn = true;
      } catch (err) {
        console.error('Failed to embed candidate photo in hall ticket:', err);
      }
    }
    // No candidate photo on file (or it failed to load) — fall back to the
    // default placeholder photo instead of an empty gray box.
    if (!profileImageDrawn) {
      try {
        doc.addImage(defaultImage, getImageFormat(defaultImage), 150, 45, 45, 45);
        profileImageDrawn = true;
      } catch (err) {
        console.error('Failed to embed default photo in hall ticket:', err);
      }
    }
    if (!profileImageDrawn) {
      doc.setFillColor(...lightGray);
      doc.rect(150, 45, 35, 45, 'F');
      doc.setFontSize(8);
      doc.setTextColor(128, 128, 128);
      doc.text('CANDIDATE', 167.5, 65, { align: 'center' });
      doc.text('PHOTO', 167.5, 72, { align: 'center' });
    }

    doc.setTextColor(...secondaryColor);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('CANDIDATE DETAILS', 20, 55);
    
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(20, 58, 140, 58);
    
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    const Candidatefname = candidate.first_name || '';
    const Candidatelname = candidate.last_name || '';
    const CandidateEmail = candidate.email || 'Not Provided';
    const CandidateMobile = candidate.mobile_no || 'Not Provided';
    const Candidategender = candidate.gender || 'male';
    const Candidateaadhar = candidate.aadhar_last || '';
    const Candidatedob = candidate.dob || '';
    
    const maskAadhar = (aadhar) => {
      if (!aadhar) return 'Not Specified';
      const clean = aadhar.toString().replace(/\s+/g, '');
      if (clean.length !== 4) return 'Invalid Aadhar';
      return 'xxxx xxxx ' + clean.slice(-4);
    };
    
    const candidateInfo = [
      { label: 'Name:', value: `${Candidatefname} ${Candidatelname}`.trim() || 'CANDIDATE NAME' },
      { label: 'Email:', value: CandidateEmail },
      { label: 'Mobile:', value: CandidateMobile },
      { label: 'Gender:', value: Candidategender || 'Not Specified' },
      { 
        label: 'DOB:',
        value: Candidatedob
          ? new Date(Candidatedob).toLocaleDateString('en-GB')
          : 'Not Specified'
      },
      { label: 'Registration Date:', value: new Date(test.register_start_date).toLocaleString("en-GB") },
      { label: 'Aadhar Number:', value: maskAadhar(Candidateaadhar) },
    ];
    
    let yPos = 68;
    candidateInfo.forEach(info => {
      doc.setFont('helvetica', 'bold');
      doc.text(info.label, 20, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(info.value, 60, yPos);
      yPos += 8;
    });
    
    doc.setTextColor(...secondaryColor);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('EXAMINATION DETAILS', 20, 125);
    doc.line(20, 128, 190, 128);
    
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    const testInfo = [
      { label: 'Test Title:', value: test.test_title || 'TEST NAME' },
      { label: 'Test Desc:', value: test.test_desc || 'TEST001' },
      { label: 'Start Date & Time:', value: new Date(test.test_start_time).toLocaleString("en-GB") },
      { label: 'End Date & Time:', value: new Date(test.test_end_time).toLocaleString("en-GB") },
      { label: 'Fees Paid:', value: `${test.fees}/-` },
      { label: 'Venue:', value: test.venue || 'EXAMINATION CENTER' },
    ];
    
    yPos = 138;
    testInfo.forEach(info => {
      doc.setFont('helvetica', 'bold');
      doc.text(info.label, 20, yPos);
      doc.setFont('helvetica', 'normal');
      const maxWidth = 120;
      const lines = doc.splitTextToSize(info.value, maxWidth);
      doc.text(lines, 70, yPos);
      yPos += lines.length > 1 ? lines.length * 7 : 8;
    });

    doc.setTextColor(...secondaryColor);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('IMPORTANT INSTRUCTIONS', 20, 210);
    doc.line(20, 213, 190, 213);
    
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    
    const instructions = [
      '1. Candidates must bring this hall ticket to the examination center.',
      '2. Carry a valid photo ID proof along with the hall ticket.',
      '3. Report to the examination center 30 minutes before the scheduled time.',
      '4. Mobile phones and electronic devices are strictly prohibited.',
      '5. Late entry will not be allowed under any circumstances.'
    ];
    
    yPos = 223;
    instructions.forEach(instruction => {
      doc.text(instruction, 20, yPos);
      yPos += 6;
    });
    
    doc.setFillColor(...lightGray);
    doc.rect(0, 270, 210, 27, 'F');
    
    doc.setTextColor(...secondaryColor);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'italic');
    doc.text('This is a computer-generated hall ticket. No signature is required.', 105, 280, { align: 'center' });
    doc.text(`Generated on: ${new Date().toLocaleDateString("en-GB")}`, 105, 287, { align: 'center' });
    
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(1);
    doc.rect(5, 5, 200, 287);
    
    doc.save(`${test.test_title}_HallTicket.pdf`);
  };

  const hasResultColumn = tests.some((test) => test.result_status != null);

  const downloadCertificate = async (testId) => {
    try {
      let Candidateid = null;

      if (userType === "candidate") {
        Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
        if (!Candidateid) {
          console.error("Candidate ID not found in sessionStorage");
          return;
        }
      } else {
        console.error("Only candidates can fetch certificates");
        return;
      }

      const endpoint = `${baseurl}/testcandidates/certificate/download?testId=${testId}&candidateId=${Candidateid}`;
      const response = await axios.get(endpoint);
      const result = response.data;

      if (!result || !Array.isArray(result.url) || result.url.length === 0) {
        alert("No certificates found.");
        return;
      }

      result.url.forEach(({ filename, presignedUrl }) => {
        const link = document.createElement("a");
        link.href = presignedUrl;
        link.download = filename;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      console.error("Error fetching certificate:", error);
      alert("Something went wrong while downloading certificate.");
    }
  };

  const handleAddFileSelect = (priorId, file) => {
    if (!file) return;
    if (file.size > MAX_FILE_SIZE) {
      Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: "File size must not exceed 1 MB.",
        showConfirmButton: false, timer: 2500, timerProgressBar: true
      });
      return;
    }
    setAddFileSelections((prev) => ({ ...prev, [priorId]: file }));
  };

  const addPriorFile = async (priorId) => {
    const file = addFileSelections[priorId];
    if (!file) {
      Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: "Please choose a file first.",
        showConfirmButton: false, timer: 2000, timerProgressBar: true
      });
      return;
    }
    setAddingFileId(priorId);
    try {
      const formData = new FormData();
      formData.append("files", file);

      await axios.post(
        `${baseurl}/PriorEvidence/addfile?priorEvidenceRegistrationId=${priorId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "File added successfully.",
        showConfirmButton: false, timer: 2000, timerProgressBar: true
      }).then(() => {
        setAddFileSelections((prev) => {
          const next = { ...prev };
          delete next[priorId];
          return next;
        });
        fetchPrior();
      });
    } catch (error) {
      console.error("Error adding prior evidence file:", error);
      Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: "Failed to add file. Please check file size (max 1 MB).",
        showConfirmButton: false, timer: 2500, timerProgressBar: true
      });
    } finally {
      setAddingFileId(null);
    }
  };
  const downloadPriorCertificate = async (priorEvidenceRegistrationId) => {
    try {
      const endpoint = `${baseurl}/testcandidate/certificate/${priorEvidenceRegistrationId}`;
      const response = await axios.get(endpoint);
      const result = response.data;

      if (!result || !Array.isArray(result.url) || result.url.length === 0) {
        alert("No certificates found.");
        return;
      }

      result.url.forEach(({ filename, presignedUrl }) => {
        const link = document.createElement("a");
        link.href = presignedUrl;
        link.download = filename;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      console.error("Error fetching prior evidence certificate:", error);
      alert("Something went wrong while downloading certificate.");
    }
  };

  const capitalize = (val) => {
    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
  };

  const fetchFees = async () => {
    try {
      const response = await axios.get(`${baseurl}/admin/getFees`);
      const feeMap = {};
      response.data.forEach(fee => {
        const typeKey = fee.type.trim();
        feeMap[typeKey] = Number(fee.fees);
      });
      console.log("Fixed Fee Map:", feeMap);
      setFeeData(feeMap);
    } catch (error) {
      console.error("Error fetching fees:", error);
      alert("Failed to fetch fees.");
    }
  };

  const isValidImage = (img) => {
    if (!img || img.trim() === "") return false;
    const parts = img.split(",");
    return parts.length === 2 && parts[0].startsWith("data:image") && parts[1].trim() !== "" && !parts[1].trim().startsWith("http");
  };

  const applyForMembership = (cid) => {
    setSelectedCandidate(cid);
    setShowMemberModal(true);
    fetchFees();
  };

  const TERM_RANK = {
    Annual: 1,
    "5Years": 2,
    Life: 3,
  };

  function getPurchaseContext(member, selectedTerm, showRestart) {
    // Restart has highest priority
    if (showRestart) {
      return "restart";
    }

    const currentRank = TERM_RANK[member.membership_term];
    const selectedRank = TERM_RANK[selectedTerm];

    // Same membership term
    if (selectedRank === currentRank) {
      return "renew";
    }

    // Higher membership term
    if (selectedRank > currentRank) {
      return "upgrade";
    }

    // Lower membership term / invalid combination
    return null;
  }

  const expDate = new Date(member.membership_exp_date);
  const today = new Date();
  const diffTime = today - expDate;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  const isExpired = expDate < today;
  const isMoreThanOneYear = diffDays > 365;
  const showRestart = isExpired && isMoreThanOneYear;
  const threeMonthsBefore = new Date(expDate);
  threeMonthsBefore.setMonth(threeMonthsBefore.getMonth() - 3);
  const showRenew = today >= threeMonthsBefore;

  const showUpgrade =
  !isExpired &&
  member.status_name &&
  TERM_RANK[member.status_name] < TERM_RANK.Life;

  // ── Derived config for the currently selected ID type ────────────────────
  const selectedIdCfg = ID_TYPE_CONFIG[profile.id_type] || ID_TYPE_CONFIG.aadhaar;

  return (
    <div style={{ marginTop: "100px" }}>
      <div className="event" style={{ marginTop: "20px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav
                className="wow fadeInDown animated"
                data-animation="fadeInDown animated"
                data-delay=".2s"
                style={{ visibility: "visible", animationName: "fadeInDown" }}
              >
                <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                  {userType === "candidate" ? (
                    <a className="nav-item nav-link active show" id="nav-home-tab"
                      data-toggle="tab" href="#one" role="tab" aria-selected="false">
                      <div className="nav-content"><strong>Test</strong></div>
                    </a>
                  ) : (
                    <a className="nav-item nav-link active show" id="nav-home-tab"
                      data-toggle="tab" href="#one" role="tab" aria-selected="false">
                      <div className="nav-content"><strong>Membership Details</strong></div>
                    </a>
                  )}
                  {userType === "candidate" ? (
                    <a className="nav-item nav-link" id="nav-contact-tab"
                      data-toggle="tab" href="#two" role="tab" aria-selected="false">
                      <div className="nav-content"><strong>Pre-Test</strong></div>
                    </a>
                  ) : ""}
                  {userType === "candidate" && (
                    <a className="nav-item nav-link" id="nav-cat-tab"
                      data-toggle="tab" href="#cat" role="tab" aria-selected="false">
                      <div className="nav-content"><strong>CAT</strong></div>
                    </a>
                  )}
                  {userType === "candidate" ? (
                    <a className="nav-item nav-link" id="nav-contact-tab"
                      data-toggle="tab" href="#three" role="tab" aria-selected="false">
                      <div className="nav-content"><strong>Prior Evidence</strong></div>
                    </a>
                  ) : (
                    <a className="nav-item nav-link" id="nav-contact-tab"
                      data-toggle="tab" href="#three" role="tab" aria-selected="false">
                      <div className="nav-content"><strong>History</strong></div>
                    </a>
                  )}
                  <a className="nav-item nav-link" id="nav-contact-tab"
                    data-toggle="tab" href="#four" role="tab" aria-selected="false">
                    <div className="nav-content"><strong>Edit Profile</strong></div>
                  </a>
                  <a className="nav-item nav-link" id="nav-contact-tab2"
                    data-toggle="tab" href="#four" role="tab" aria-selected="false"
                    onClick={handleLogout}>
                    <div className="nav-content"><strong>LogOut</strong></div>
                  </a>
                </div>
              </nav>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="tab-content wow fadeInDown animated"
                data-animation="fadeInDown animated"
                data-delay=".2s"
                id="nav-tabContent"
                style={{ visibility: "visible", animationName: "fadeInDown" }}
              >
                {/* ── Tab 1: Test / Membership Details ── */}
                <div className="tab-pane fade active show" id="one" role="tabpanel"
                  aria-labelledby="nav-home-tab" style={{ marginBottom: "50px" }}>
                  {userType === "candidate" ? (
                    <div className="row">
                      <div className="d-flex justify-content-between align-items-center">
                        <h1 className="m-0">Register Test List:</h1>
                        <button className="btn btn-primary"
                          onClick={() => navigate("/JoinUs", { state: { tab: "#two" } })}>
                          + Register Test
                        </button>
                      </div>

                      <div className="col-md-12">
                        <hr style={{ width: "100%", color: "blue" }} />
                        {tests.length > 0 ? (
                          <table className="table table-bordered mt-3">
                            <thead className="table-primary">
                              <tr>
                                <th>Test</th>
                                <th>Test Start Date</th>
                                <th>Test End Date</th>
                                <th>Fees</th>
                                <th style={{ textAlign: "center" }}>Download</th>
                                {/* {hasResultColumn && <th style={{ textAlign: "center" }}>Result</th>} */}
                              </tr>
                            </thead>
                            <tbody>
                              {tests.map((tests, index) => {
                                const TeststartDate = new Date(tests.test_start_time);
                                const TestendDate = new Date(tests.test_end_time);
                                const formattedstartDate = TeststartDate.toLocaleDateString("en-GB");
                                const formattedstartTime = TeststartDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                const formattedendDate = TestendDate.toLocaleDateString("en-GB");
                                const formattedendTime = TestendDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                return (
                                  <tr key={index}>
                                    <td className="candTable">{tests.test_title}</td>
                                    <td className="candTable">{formattedstartDate}&nbsp;&nbsp;{formattedstartTime}</td>
                                    <td className="candTable">{formattedendDate}&nbsp;&nbsp;{formattedendTime}</td>
                                    <td className="candTable">{tests.fees || 1000}/-</td>
                                    <td style={{ paddingTop: "20px", textAlign: "center" }}>
                                      <button className="btn btn-success" onClick={() => downloadHallTicket(tests,profile)}>
                                        Hall Ticket
                                      </button>
                                      &nbsp;
                                      {hasResultColumn && (tests.result_status === 'Pass' || tests.result_status === 'Fail') && tests.certificate &&(
                                        <button className="btn btn-primary"
                                          onClick={() => downloadCertificate(tests.test_id)}>
                                          Certificate
                                        </button>
                                      )}
                                      &nbsp;
                                      {hasResultColumn && tests.result_status === 'Pass' && tests.certificate &&(
                                        <button className="btn btn-primary"
                                          onClick={() => applyForMembership(cid)}>
                                          Apply For Member
                                        </button>
                                      )}
                                    </td>
                                    {/* {hasResultColumn && (
                                      <td className={`candTable fw-bold ${
                                        tests.result_status === 'Pass' ? 'text-success' :
                                        tests.result_status === 'Fail' ? 'text-danger' : ''
                                      }`}>
                                        {tests.result_status}
                                      </td>
                                    )} */}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center text-danger mt-3">No Data Found</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-7">
                        <h2 className="mb-4">Membership Card Details</h2>
                        <hr style={{ width: "100%", color: "blue" }} />
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Date of Joining:</div>
                          <div className="col-6">{new Date(member.date_joining).toLocaleDateString('en-GB')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Last Renewal Date:</div>
                          <div className="col-6">{new Date(member.last_renewal_date).toLocaleDateString('en-GB')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Membership Expiry:</div>
                          <div className="col-6">{new Date(member.membership_exp_date).toLocaleDateString('en-GB')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Status:</div>
                          <div className="col-6">
                            <span style={{
                              color: new Date(member.membership_exp_date) < new Date() ? "red" : "green",
                              fontWeight: "bold",
                            }}>
                              {new Date(member.membership_exp_date) < new Date() ? "EXPIRED" : member.status_name}
                            </span>
                          </div>
                        </div>
                        <br />
                        <h2 className="mb-4">Membership Profile Details</h2>
                        <hr style={{ width: "100%", color: "blue" }} />
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Chapter:</div>
                          <div className="col-6">{member.chapter_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Membership Number:</div>
                          <div className="col-6">{member.membership_no}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Member Name:</div>
                          <div className="col-6">{member.first_name} {member.last_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Gender:</div>
                          <div className="col-6">{member.gender}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Date of Birth:</div>
                          <div className="col-6">{new Date(member.dob).toLocaleDateString('en-GB')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-6 fw-bold">Mobile Number:</div>
                          <div className="col-6">{member.mobile_no}</div>
                        </div>
                        <br />
                        <hr style={{ width: "100%", color: "blue" }} />
                        <h2 className="mb-4">Interchapter Transfer</h2>
                        <span>If you wish to transfer chapter in India </span>&nbsp;
                        <Button variant="link" onClick={handleShow} style={{ color: 'white', marginTop: '10px' }}>
                          CLICK HERE
                        </Button>

                        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                          <Modal.Header closeButton>
                            <Modal.Title>Transfer Chapter</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form onSubmit={handleSubmit}>
                              <Form.Group className="mb-3" controlId="formChapter">
                                <Form.Label>Select Chapter</Form.Label>
                                <Form.Select value={chapter} onChange={(e) => setChapter(e.target.value)} required>
                                  <option value="" disabled>-- Select Chapter --</option>
                                  {chapters.map((chapter) => (
                                    <option key={chapter.chapter_id} value={chapter.chapter_id}>
                                      {chapter.chapter_name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                              <Form.Group className="mb-3" controlId="formReason">
                                <Form.Label>Reason for Transfer</Form.Label>
                                <Form.Control as="textarea" rows={3} value={reason}
                                  onChange={(e) => setReason(e.target.value)} required />
                              </Form.Group>
                              <div className="d-flex justify-content-end">
                                <Button variant="secondary" onClick={handleClose} className="me-2">Cancel</Button>
                                <Button variant="primary" type="submit">Submit</Button>
                              </div>
                            </Form>
                          </Modal.Body>
                        </Modal>

                        <Modal show={intshow} onHide={handleintClose} backdrop="static" keyboard={false}>
                          <Modal.Header closeButton>
                            <Modal.Title>International Chapter</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form onSubmit={handleintSubmit}>
                              <Form.Group className="mb-3" controlId="formReason">
                                <Form.Label>Reason for Transfer</Form.Label>
                                <Form.Control as="textarea" rows={3} value={reason}
                                  onChange={(e) => setReason(e.target.value)} required />
                              </Form.Group>
                              <div className="d-flex justify-content-end">
                                <Button variant="secondary" onClick={handleintClose} className="me-2">Cancel</Button>
                                <Button variant="primary" type="submit">Submit</Button>
                              </div>
                            </Form>
                          </Modal.Body>
                        </Modal>

                        <br /><br />
                        <hr style={{ width: "100%", color: "blue" }} />
                        <h2 className="mb-4">International Transfer</h2>
                        <span>If you wish to transfer chapter </span>&nbsp;
                        <Button variant="link" onClick={handleInternationalShow} style={{ color: 'white', marginTop: '10px' }}>
                          CLICK HERE
                        </Button>
                      </div>

                      <div className="col-md-5 d-flex flex-column align-items-center">
                        {(showRenew || showRestart || showUpgrade) && (
                          <div className="row">
                            <h2 className="mb-4">Renew Membership</h2>
                            <hr style={{ width: "100%", color: "blue" }} />
                            {showRestart ? (
                              <span style={{ color: "red", fontWeight: "600" }}>❌ Your membership has expired.</span>
                            ) : new Date(member.membership_exp_date) < new Date() ? (
                              <span style={{ color: "red", fontWeight: "600" }}>⚠️ Your membership expired recently.</span>
                            ) : showRenew ? (
                              <span style={{ color: "orange", fontWeight: "600" }}>
                                ⏳ Your membership expires on{" "}
                                {new Date(member.membership_exp_date).toLocaleDateString("en-IN", {
                                  day: "2-digit", month: "short", year: "numeric",
                                })}. Renew early to avoid interruption.
                              </span>
                            ) : (
                              <span style={{ color: "#555", fontWeight: "600" }}>
                                Your {member.membership_term} membership is active until{" "}
                                {new Date(member.membership_exp_date).toLocaleDateString("en-IN", {
                                  day: "2-digit", month: "short", year: "numeric",
                                })}. You can upgrade your term anytime.
                              </span>
                            )}

                            <div style={{ marginTop: "15px", marginBottom: "10px" }}>
                              <label htmlFor="renewTerm" style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                                Select Membership Term
                              </label>
                              <select id="renewTerm" value={selectedTerm}
                                onChange={(e) => setSelectedTerm(e.target.value)}
                                style={{ padding: "10px 16px", borderRadius: "8px", cursor: "pointer" }}>
                                <option value="">-- Select Term --</option>
                                <option value="Annual">Annual</option>
                                <option value="5Years">5 Years</option>
                                <option value="Life">Life</option>
                              </select>
                            </div>

                            {selectedTerm && (() => {
                              const context = getPurchaseContext(member, selectedTerm, showRestart);
                              return (
                                <>
                                  {context === "upgrade" && (
                                    <p style={{ color: "green", fontWeight: 500 }}>
                                      You're upgrading from {member.membership_term} to {selectedTerm}.
                                    </p>
                                  )}

                                  {context === "addon" && (
                                    <p style={{ color: "green", fontWeight: 500 }}>
                                      This will be added on top of your active {member.membership_term} membership.
                                    </p>
                                  )}

                                  <HiddenPayuForm
                                    testId={
                                      context === null
                                        ? selectedTerm
                                        : `${selectedTerm}-${context}`
                                    }
                                  />
                                </>
                              );
                            })()}
                          </div>
                        )}
                        <br />
                        {!showRenew && !showRestart && (
                          <>
                            <hr style={{ width: "100%", color: "blue" }} />
                            <div className="row" style={{ alignSelf: "start" }}>
                              <h2 className="mb-3">Order Card</h2>
                              {isValidImage(member.member_img) ? (
                                <div className="row">
                                  <div className="col-md-8">
                                    <p>If You want to Order Card Please click</p>
                                  </div>
                                  <br />
                                  <div className="col-md-12 mb-3">
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox"
                                        id="addressConfirmCheck" checked={addressConfirmed}
                                        onChange={(e) => setAddressConfirmed(e.target.checked)} />
                                      <label className="form-check-label" htmlFor="addressConfirmCheck">
                                        Card will be sent on address in database, the address is correct.
                                      </label>
                                    </div>
                                  </div>
                                  <br />
                                  {addressConfirmed && (
                                    <div className="col-md-6">
                                      {/* {isFreeCardEligible(member) ? (
                                        <button style={{
                                          marginTop: "5px", padding: "12px 30px",
                                          background: "linear-gradient(135deg, rgb(34, 139, 34), rgb(50, 168, 50))",
                                          color: "white", border: "none", borderRadius: "25px",
                                          fontSize: "14px", fontWeight: "600", letterSpacing: "0.5px",
                                          cursor: "pointer", boxShadow: "0 4px 15px rgba(50, 168, 50, 0.3)",
                                          transition: "all 0.3s ease", textTransform: "uppercase",
                                        }}
                                          onClick={() => handleOrderCard(true)}
                                          onMouseOver={(e) => { e.target.style.transform = "translateY(-2px)"; e.target.style.boxShadow = "0 6px 20px rgba(50, 168, 50, 0.4)"; }}
                                          onMouseOut={(e) => { e.target.style.transform = "translateY(0)"; e.target.style.boxShadow = "0 4px 15px rgba(50, 168, 50, 0.3)"; }}
                                        >
                                          order card
                                        </button>
                                      ) : ( */}
                                        <HiddenPayuForm testId={`Card`} />
                                      {/* )} */}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="col-md-12" style={{ color: "red" }}>
                                  <p>Please add profile image.</p>
                                </div>
                              )}
                            </div>
                           
                            <hr style={{ width: "100%", color: "blue" }} />

                            <div className="row">
                              <h2 className="mb-3">Order Plaque</h2>

                              <div className="row">
                                <div className="col-md-12">
                                  <span>If You want to Order Plaque Please click</span>

                                  {/* Address Confirmation */}
                                  <div className="form-check mt-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="plaqueAddressConfirm"
                                      checked={plaqueAddressConfirmed}
                                      onChange={(e) => setPlaqueAddressConfirmed(e.target.checked)}
                                    />

                                    <label
                                      className="form-check-label"
                                      htmlFor="plaqueAddressConfirm"
                                    >
                                      Plaque will be sent on address in database, the address is correct.
                                    </label>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-6">
                                    {plaqueAddressConfirmed && (
                                      <HiddenPayuForm testId={`Plaque`} />
                                    )}
                                    <br />
                                    <Button variant="secondary" onClick={() => setShowPlaqueModal(true)}>
                                      View Plaque
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <br /><br />

                        {/* Membership Card */}
                        <div className="membership-card" ref={cardRef} style={{
                          width: "100%", maxWidth: "400px", height: "250px",
                          borderRadius: "12px", overflow: "hidden",
                          boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          position: "relative", border: "2px solid #fff",
                          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                        }}>
                          <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: `radial-gradient(circle at 20% 20%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 40% 40%, rgba(255,255,255,0.05) 0%, transparent 50%)`, zIndex: 1 }} />
                          <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: `repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)`, zIndex: 1 }} />
                          <div style={{ background: "rgba(255,255,255,0.95)", padding: "12px 20px", borderBottom: "3px solid #2c3e50", position: "relative", zIndex: 2 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <div><img src="assets/img/logo/mensatrans2.png" alt="Mensa Logo" style={{ width: "45px", height: "45px", objectFit: "contain" }} /></div>
                              <div style={{ textAlign: "center", flex: 1 }}>
                                <h6 style={{ margin: "0", fontSize: "16px", fontWeight: "700", color: "#2c3e50", letterSpacing: "0.5px" }}>MENSA INDIA</h6>
                                <p style={{ margin: "0", fontSize: "11px", color: "#7f8c8d", fontWeight: "600", letterSpacing: "0.3px" }}>MEMBERSHIP CARD</p>
                              </div>
                              <div style={{ width: "45px", height: "45px", background: "linear-gradient(135deg, #3498db, #2980b9)", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "12px", fontWeight: "bold" }}>ID</div>
                            </div>
                          </div>
                          <div style={{ padding: "20px", height: "calc(100% - 80px)", position: "relative", zIndex: 2, background: "rgba(255,255,255,0.9)" }}>
                            <div style={{ display: "flex", height: "100%" }}>
                              <div style={{ marginRight: "20px" }}>
                                <div style={{ width: "80px", height: "80px", borderRadius: "8px", overflow: "hidden", border: "3px solid #ecf0f1", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                                  <img src={member.member_img || "assets/img/logo/mensatrans2.png"} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                </div>
                              </div>
                              <div style={{ flex: 1 }}>
                                <h5 style={{ margin: "0 0 8px 0", fontSize: "18px", fontWeight: "700", color: "#2c3e50", letterSpacing: "0.3px" }}>
                                  {member.first_name} {member.last_name}
                                </h5>
                                <div style={{ marginBottom: "8px" }}>
                                  <span style={{ fontSize: "10px", color: "#7f8c8d", fontWeight: "600", letterSpacing: "0.5px" }}>MEMBERSHIP NO.</span>
                                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#e74c3c", letterSpacing: "1px", fontFamily: "monospace" }}>{member.membership_no}</div>
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                  <span style={{ fontSize: "10px", color: "#7f8c8d", fontWeight: "600", letterSpacing: "0.5px" }}>VALID TILL</span>
                                  <div style={{ fontSize: "13px", fontWeight: "700", color: "#7f8c8d", letterSpacing: "0.3px" }}>
                                    {new Date(member.membership_exp_date).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                  </div>
                                </div>
                                {member.membership_exp_date && (
                                  <div style={{ position: "absolute", bottom: "15px", right: "15px", background: new Date(member.membership_exp_date) < new Date() ? "linear-gradient(135deg, #e74c3c, #c0392b)" : "linear-gradient(135deg, #27ae60, #2ecc71)", color: "white", padding: "4px 12px", borderRadius: "20px", fontSize: "10px", fontWeight: "600", letterSpacing: "0.5px", textTransform: "uppercase", boxShadow: new Date(member.membership_exp_date) < new Date() ? "0 2px 8px rgba(231, 76, 60, 0.3)" : "0 2px 8px rgba(46, 204, 113, 0.3)" }}>
                                    {new Date(member.membership_exp_date) < new Date() ? "EXPIRED" : "ACTIVE"}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div style={{ position: "absolute", bottom: "0", left: "0", right: "0", height: "4px", background: "linear-gradient(90deg, #e74c3c, #f39c12, #f1c40f, #27ae60, #3498db, #9b59b6)" }} />
                          <div style={{ position: "absolute", top: "60px", right: "10px", width: "30px", height: "30px", background: "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.5) 50%, transparent 70%)", borderRadius: "50%", zIndex: 3, opacity: 0.7 }} />
                        </div>

                        <button onClick={downloadCardImage} style={{
                          marginTop: "20px", padding: "12px 30px",
                          background: "linear-gradient(135deg, #27ae60, #2ecc71)",
                          color: "white", border: "none", borderRadius: "25px",
                          fontSize: "14px", fontWeight: "600", letterSpacing: "0.5px",
                          cursor: "pointer", boxShadow: "0 4px 15px rgba(46, 204, 113, 0.3)",
                          transition: "all 0.3s ease", textTransform: "uppercase"
                        }}
                          onMouseOver={(e) => { e.target.style.transform = "translateY(-2px)"; e.target.style.boxShadow = "0 6px 20px rgba(46, 204, 113, 0.4)"; }}
                          onMouseOut={(e) => { e.target.style.transform = "translateY(0)"; e.target.style.boxShadow = "0 4px 15px rgba(46, 204, 113, 0.3)"; }}
                        >
                          📥 Download Card as Image
                        </button>
                      </div>
                    </div>
                  )}

                  <Modal show={showMemberModal} onHide={() => setShowMemberModal(false)} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton>
                      <Modal.Title>Apply for Membership</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Select Chapter</Form.Label>
                          <Form.Select value={chapter} onChange={(e) => setChapter(e.target.value)} required>
                            <option value="">-- Select Chapter --</option>
                            {chapters.map((chapter) => (
                              <option key={chapter.chapter_id} value={chapter.chapter_id}>{chapter.chapter_name}</option>
                            ))}
                          </Form.Select>
                          <br />
                          <Form.Label>Select Membership Term</Form.Label>
                          <Form.Select value={selectedTerm} onChange={(e) => setSelectedTerm(e.target.value)} required>
                            <option value="">-- Select Term --</option>
                            <option value="Annual">Annual</option>
                            <option value="5Years">5 Years</option>
                            <option value="Life">Life</option>
                          </Form.Select>
                        </Form.Group>
                        {selectedTerm && (
                          <div className="mb-3">
                            <p><strong>Joining Fee:</strong> ₹{feeData["Joiningfees"] || 0}</p>
                            <p><strong>Membership Fee:</strong> ₹{feeData[selectedTerm] || 0}</p>
                            <hr />
                            <p><strong>Total:</strong> ₹{(feeData["Joiningfees"] || 0) + (feeData[selectedTerm] || 0)}</p>
                          </div>
                        )}
                      </Form>
                      {selectedTerm && (
                        <HiddenPayuForm testId={`${selectedTerm}-new-${chapter}`} />
                      )}
                    </Modal.Body>
                  </Modal>
                </div>

                {/* ── Tab: CAT ── */}
                {userType === "candidate" && (
                  <div className="tab-pane fade" id="cat" role="tabpanel"
                    aria-labelledby="nav-cat-tab" style={{ marginBottom: "50px" }}>
                    <div className="row">
                      <div className="d-flex justify-content-between align-items-center">
                        <h1 className="m-0">Register CAT List:</h1>
                        <div>
                          <button className="btn btn-primary" onClick={registerCat}>
                            + Register CAT
                          </button>
                          &nbsp;
                          <button className="btn btn-primary" style={{ color: "#fff" }} onClick={viewCatRegistration}>
                            View Registration
                          </button>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <hr style={{ width: "100%", color: "blue" }} />
                        {tests.filter((t) => /\bCAT\b/i.test(t.test_title || "")).length > 0 ? (
                          <table className="table table-bordered mt-3">
                            <thead className="table-primary">
                              <tr>
                                <th>CAT</th>
                                <th>CAT Start Date</th>
                                <th>CAT End Date</th>
                                <th>Fees</th>
                                <th style={{ textAlign: "center" }}>Download</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tests.filter((t) => /\bCAT\b/i.test(t.test_title || "")).map((t, index) => {
                                const start = new Date(t.test_start_time);
                                const end = new Date(t.test_end_time);
                                const timeOpts = { hour: "2-digit", minute: "2-digit" };
                                return (
                                  <tr key={index}>
                                    <td className="candTable">{t.test_title}</td>
                                    <td className="candTable">{start.toLocaleDateString("en-GB")}&nbsp;&nbsp;{start.toLocaleTimeString([], timeOpts)}</td>
                                    <td className="candTable">{end.toLocaleDateString("en-GB")}&nbsp;&nbsp;{end.toLocaleTimeString([], timeOpts)}</td>
                                    <td className="candTable">{t.fees || 1000}/-</td>
                                    <td style={{ paddingTop: "20px", textAlign: "center" }}>
                                      <button className="btn btn-success" onClick={() => downloadHallTicket(t, profile)}>
                                        Hall Ticket
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center text-danger mt-3">No Data Found</p>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* ── Tab 2: Pre-Test ── */}
                <div className="tab-pane fade" id="two" role="tabpanel" aria-labelledby="nav-profile-tab">
                  {userType === "candidate" ? (
                    <div className="row">
                      <div className="d-flex justify-content-between align-items-center">
                        <h1 className="m-0">Register Pre-test List :</h1>
                        <button className="btn btn-primary"
                          onClick={() => navigate("/JoinUs", { state: { tab: "#five" } })}>
                          + Register Pre-Test
                        </button>
                      </div>
                      <div className="col-md-12">
                        <hr style={{ width: "100%", color: "blue" }} />
                        {pretests.length > 0 ? (
                          <table className="table table-bordered mt-3">
                            <thead className="table-primary">
                              <tr>
                                <th>Pre-Test Register Date</th>
                                <th>Pre-Test Register Time</th>
                                <th>Fees</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pretests.map((pretests, index) => {
                                const preTestDate = new Date(pretests.pre_test_datetime);
                                const formattedDate = preTestDate.toLocaleDateString("en-GB");
                                const formattedTime = preTestDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                return (
                                  <tr key={index}>
                                    <td className="candTable">{formattedDate}</td>
                                    <td className="candTable">{formattedTime}</td>
                                    <td className="candTable">{pretests.fees}/-</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center text-danger mt-3">No Data Found</p>
                        )}
                      </div>
                    </div>
                  ) : ""}
                </div>

                {/* ── Tab 3: Prior Evidence / History ── */}
                <div className="tab-pane fade" id="three" role="tabpanel" aria-labelledby="nav-result-tab">
                  {userType === "candidate" ? (
                    <div className="row">
                      <div className="d-flex justify-content-between align-items-center">
                        <h1 className="m-0">Register Prior Evidence List :</h1>
                        <button className="btn btn-primary"
                          onClick={() => navigate("/JoinUs", { state: { tab: "#three" } })}>
                          + Register Prior Evidence
                        </button>
                      </div>
                      <div className="col-md-12">
                        <hr style={{ width: "100%", color: "blue" }} />
                        {prior.length > 0 ? (
                          <table className="table table-bordered mt-3">
                            <thead className="table-primary">
                              <tr>
                                <th>Prior Register Date</th>
                                <th>Prior Register Time</th>
                                <th>Fees</th>
                                <th>Document</th>
                                <th>Result</th>
                              </tr>
                            </thead>
                            <tbody>
                              {prior.map((prior, index) => {
                                const priorDate = new Date(prior.prior_evidence_date_time);
                                const formattedDate = priorDate.toLocaleDateString("en-GB");
                                const formattedTime = priorDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                const hasResult = prior.result != null && prior.result !== "" ;
                                const hasCertificate = prior.certificate != null && prior.certificate !== "";
                                const priorId = prior.prior_evidence_registration_id;
                                return (
                                  <tr key={index}>
                                    <td className="candTable">{formattedDate}</td>
                                    <td className="candTable">{formattedTime}</td>
                                    <td className="candTable">{prior.fees}/-</td>
                                    <td className="candTable" style={{ paddingTop: "20px", textAlign: "center" }}>
                                      {hasResult && hasCertificate && prior.send_mail !== null &&(
                                        <button
                                          className="downloadBtn btn btn-primary"
                                          onClick={() => downloadPriorCertificate(priorId)}
                                          style={{ marginBottom: "10px" }}
                                        >
                                          Download Certificate
                                        </button>
                                      )}
                                      {hasResult && !hasCertificate && (
                                        <span>Wait For Certificate</span>
                                      )}

                                      {!hasResult && (
                                      <div style={{ textAlign: "left" }}>
                                        <input
                                          type="file"
                                          accept=".pdf,.jpg,.jpeg,.png"
                                          onChange={(e) => handleAddFileSelect(priorId, e.target.files[0])}
                                          style={{ marginBottom: "6px" }}
                                        />
                                        <div>
                                          <br></br>
                                          <button
                                            className="btn btn-primary btn-sm"
                                            disabled={!addFileSelections[priorId] || addingFileId === priorId}
                                            onClick={() => addPriorFile(priorId)}
                                          >
                                            {addingFileId === priorId ? "Adding..." : "+ Add Missed File"}
                                          </button>
                                        </div>
                                        <small style={{ color: "red", display: "block", marginTop: "4px" }}>
                                          Max file size: 1 MB
                                        </small>
                                      </div>
                                      )}
                                    </td>
                                    
                                    <td style={{ textAlign: "center" }}
                                      className={`candTable fw-bold ${
                                        prior.result === 'Pass'
                                          ? 'text-success'
                                          : prior.result === 'Fail'
                                          ? 'text-danger'
                                          : ''
                                      }`}
                                    >
                                      {/* <p>{prior.result}</p> */}

                                      {prior.result === 'Pass' && hasCertificate && prior.send_mail !== null &&(
                                        <button
                                          className="btn btn-primary btn-sm ms-2"
                                          onClick={() => applyForMembership(cid)}
                                        >
                                          Apply For Member
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center text-danger mt-3">No Data Found</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-12">
                        <h1>Transaction History:</h1>
                        <hr style={{ width: "100%", color: "blue" }} />
                        {membertrans.length > 0 ? (
                          <table className="table table-bordered mt-3">
                            <thead className="table-primary">
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr.No</th>
                                <th style={{ textAlign: "center" }}>Date</th>
                                <th style={{ textAlign: "center" }}>Type</th>
                                <th style={{ textAlign: "center" }}>Payment Method</th>
                                <th style={{ textAlign: "center" }}>Amout</th>
                                <th style={{ textAlign: "center" }}>Payment Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {membertrans.map((membertrans, index) => {
                                const TransDate = new Date(membertrans.trans_datetime);
                                const formattedstartDate = TransDate.toLocaleDateString("en-GB");
                                const formattedstartTime = TransDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                return (
                                  <tr key={index}>
                                    <td className="candTable">{index + 1}</td>
                                    <td className="candTable" style={{ paddingTop: "20px", textAlign: "center" }}>{formattedstartDate}</td>
                                    <td className="candTable" style={{ paddingTop: "20px", textAlign: "center" }}>{membertrans.trans_type_id}</td>
                                    <td className="candTable" style={{ paddingTop: "20px", textAlign: "center" }}>{membertrans.payment_method}</td>
                                    <td style={{ paddingTop: "20px", textAlign: "center" }}>{membertrans.amount || 1000}/-</td>
                                    <td style={{ paddingTop: "20px", textAlign: "center" }}>{membertrans.payment_status}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center text-danger mt-3">No Data Found</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* ── Tab 4: Edit Profile ── */}
                <div className="tab-pane fade" id="four" role="tabpanel"
                  aria-labelledby="nav-profile-tab" style={{ marginBottom: "50px" }}>
                  <div className="container">
                    <div className="e-profile">
                      <form className="form">
                        <div className="profile-pic">
                          <img src={profilePic || defaultImage} alt="Profile" name="images"
                            className="img-fluid"
                            style={{ objectFit: "contain", height: "150px", width: "200px", border: "1px solid" }}
                            required
                          />
                          <div>
                            <br />
                            <input type="file" id="fileInput" style={{ cursor: "pointer" }}
                              accept="image/*" onChange={handleFileChange} />
                            <br />
                            {!profilePic && <span style={{ color: "red" }}>Please Select Image</span>}
                          </div>
                        </div>
                        <br />

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>First Name</label>
                              <input className="form-control" type="text" name="first_name"
                                value={profile.first_name} onChange={handleInputChange} />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Last Name</label>
                              <input className="form-control" type="text" name="last_name"
                                value={profile.last_name} onChange={handleInputChange} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Email</label>
                              <input className="form-control" type="email" name="email"
                                value={profile.email} onChange={handleInputChange} />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Mobile No</label>
                              <input className="form-control" type="text" name="mobile_no"
                                value={profile.mobile_no} onChange={handleInputChange} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Gender</label>
                              <select className="form-control" name="gender"
                                value={profile.gender ? capitalize(profile.gender) : ''}
                                onChange={handleInputChange}>
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Date of Birth</label>
                              <input className="form-control" type="date" name="dob"
                                value={profile.dob} onChange={handleInputChange} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Address</label>
                              <input className="form-control" type="text" name="address"
                                value={profile.address} onChange={handleInputChange} />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>City</label>
                              <input className="form-control" type="text" name="city"
                                value={profile.city} onChange={handleInputChange} />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>State</label>
                              <input className="form-control" type="text" name="state"
                                value={profile.state} onChange={handleInputChange} />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Pincode</label>
                              <input className="form-control" type="text" name="pincode"
                                value={profile.pincode} onChange={handleInputChange} />
                            </div>
                          </div>
                        </div>

                        {/* ── ID Document — same two-field pattern as Register.js ── */}
                        {mid === null && (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>ID Document</label>
                              <select
                                className="form-select"
                                name="id_type"
                                value={profile.id_type}
                                onChange={handleInputChange}
                              >
                                <option value="aadhaar">Aadhaar Card</option>
                                <option value="pan">PAN Card</option>
                                <option value="driving_license">Driving License</option>
                                <option value="passport">Passport</option>
                              </select>
                              <small className="text-muted">
                                Aadhaar preferred. Select another only if you don't have Aadhaar.
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Document Number of {selectedIdCfg.label}</label>
                              <input
                                className={`form-control ${idError ? "is-invalid" : ""}`}
                                type="text"
                                name="aadhar_last"
                                placeholder={selectedIdCfg.placeholder}
                                value={profile.aadhar_last}
                                onChange={handleInputChange}
                                maxLength={4}
                                required
                              />
                              <small className="text-muted">{selectedIdCfg.hint}</small>
                              {idError && (
                                <small className="text-danger d-block">{idError}</small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Last Education</label>
                              <input className="form-control" type="text" name="last_edu"
                                value={profile.last_edu} onChange={handleInputChange} required/>
                            </div>
                          </div>
                        </div>
                        )}
                        {/* ─────────────────────────────────────────────────────── */}

                        <br />
                        {isChanged && (
                          <div className="row">
                            <div className="col d-flex justify-content-center">
                              <button className="btn btn-primary" type="button"
                                onClick={updateProfile} disabled={isSaving} style={{ display: 'block' }}>
                                {isSaving ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2"
                                      role="status" aria-hidden="true" style={{ color: 'black' }} />
                                    Saving...
                                  </>
                                ) : "Save Changes"}
                              </button>
                            </div>
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>

                <Modal show={showCropModal} onHide={handleCropCancel} backdrop="static" keyboard={false} centered size="md">
                  <Modal.Header closeButton>
                    <Modal.Title>Crop Your Photo</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div style={{ position: "relative", width: "100%", height: "300px", background: "#333" }}>
                      {imageToCrop && (
                        <Cropper
                          image={imageToCrop}
                          crop={crop}
                          zoom={zoom}
                          aspect={1} // square crop for profile photo; change to 4/5 or whatever ratio you prefer
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                        />
                      )}
                    </div>
                    <div className="mt-3">
                      <label className="form-label">Zoom</label>
                      <input
                        type="range"
                        min={1}
                        max={3}
                        step={0.1}
                        value={zoom}
                        onChange={(e) => setZoom(Number(e.target.value))}
                        className="form-range"
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCropCancel}>Cancel</Button>
                    <Button variant="primary" onClick={handleCropConfirm}>Save Crop</Button>
                  </Modal.Footer>
                </Modal>

               <Modal
  show={showPlaqueModal}
  onHide={() => setShowPlaqueModal(false)}
  centered
  size="md"
>
  <Modal.Body style={{ padding: 0 }}>
    <div style={{ position: "relative", width: "100%", border: "9px solid #6d1b1e" }}>
      {/* The actual plaque design image */}
      <img
        src="./assets/img/plaque-design.png"
        alt="Mensa Plaque"
        style={{ width: "100%", display: "block", border:"15px solid #e3ca83" }}
      />

      {/* Dynamic name overlaid on top of the image */}
      <div
        style={{
          position: "absolute",
          top: "48%",           // adjust % until it lands exactly on the name line in your image
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          textAlign: "center",
          fontWeight: 700,
          fontSize: "22px",
          letterSpacing: "1px",
          textTransform: "uppercase",
          color: "#e9c595",     // match the gold text color in the image
          fontFamily: "'Georgia', 'Times New Roman', serif",
        }}
      >
        {`${member?.first_name || ""} ${member?.last_name || ""}`.trim() || "MEMBER NAME"}
      </div>
    </div>
  </Modal.Body>
</Modal>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;